// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___A1pin","root__title":"style-module__root__title___xMHOf","root__main":"style-module__root__main___vqHWm","root__list":"style-module__root__list___xZKv_","root__list__item":"style-module__root__list__item___Pvbig","root__block":"style-module__root__block___CyJgz","root__wrapper":"style-module__root__wrapper___OVKFf","root__wrapper__title":"style-module__root__wrapper__title___z2gOD","root__wrapper__text":"style-module__root__wrapper__text___BqbAy"};
    if(module.hot) {
      // 1697460476186
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  